{
	"accounts": "Comptes",
	"invitations": "Invitations",
	"subscribeToFeedback": "S’inscrire au programme de feedback",
	"notificationSettings": {
		"title": "Paramètres des notifications par e-mail",
		"invoicingInformation": "Informations de facturation",
		"declarationProcessingStatus": "Statut de traitement de la déclaration",
		"enabled": "Activé",
		"disabled": "Désactivé",
		"toast": {
			"success": "Préférence de notification mise à jour",
			"error": "Échec de la mise à jour de la préférence de notification"
		}
	},
	"about": {
		"title": "À propos",
		"termsAndConditions": "Conditions générales",
		"privacyPolicy": "Politique de confidentialité",
		"imprint": "Mentions légales",
		"openSourceAttribution": "Attribution open source"
	},
	"language": {
		"title": "Langue",
		"footer": "Les changements de langue seront appliqués à toutes les applications Heidelberg Materials"
	},
	"impressum": "Mentions légales",
	"copyright": "© 2024 Heidelberg Materials. Tous droits réservés.",
	"login": "Connexion",
	"logout": "Déconnexion"
}
